<template>
  <div class="qualitylayer-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('qualitylayer_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-quality-high</v-icon>{{$t('profile.quality.layers')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <QualityLayerFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.height" slot-scope="{ item }">
                  {{ $n(item['height']) }}
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import QualityLayerFilterForm from '../../components/qualitylayer/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'QualityLayerList',
  servicePrefix: 'QualityLayer',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    QualityLayerFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.quality.height'), value: 'height' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['height'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('qualitylayer', {
      items: 'list'
    }),
    ...mapFields('qualitylayer', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('qualitylayer', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
